import { bindActionCreators, compose } from 'redux';
import { lazy } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as Actions from '../../actions.js';
import injectReducer from '../../../../utils/injectReducer.js';
import injectSaga from '../../../../utils/injectSaga.js';
import saga from '../../sagas.js';
import Reducer from '../../reducer.js';
import * as cartActions from '../../../../services/Cart/actions';
import cartSaga from '../../../../services/Cart/sagas';
import cartReducer from '../../../../services/Cart/reducer';
import cBandSaga from '../../../CBandPlans/sagas';
import cBandReducer from '../../../CBandPlans/reducer';
import * as cBandActions from '../../../CBandPlans/actions';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import taggingSaga from '../../../Common/Tagging.js/sagas';

const AddressSearch = lazy(() => import('../../../../components/Web/AddressSearch/index.js'));

const mapStateToProps = (state) => {
  const stateValue = state?.AddressSearch;
  return {
    fccLabel: {
      detailList: stateValue?.fccLabelList,
      error: stateValue?.fccError,
    },
    fccProspectLabel: {
      ProspectDetailList: stateValue?.fccProspectPlansList,
      error: stateValue?.fccProspectError,
    },

    parsedAddress: stateValue?.parsedAddress,
    retrieveZipCodeDetails: {
      details: stateValue?.retrieveZipCodeSuccess,
      error: stateValue?.retrieveZipCodeError,
    },
    errorMessage: {
      value: stateValue?.showErrorBanner,
      errortext: stateValue?.errorText,
    },
    addressDetails: {
      suggestionList: state?.cartDetails?.availableAddress?.addresses || [],
      error: state?.cartDetails?.showAddressError || false,
    },
    usertypedAddress: stateValue?.usertypedAddress || '',
    userSelectedAddress: stateValue?.userSelectedAddress || '',
    enableContinueButton: stateValue?.enableContinueButton || false,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...Actions,
      ...cartActions,
      ...cBandActions,
      ...taggingActions,
    },
    dispatch,
  );
}
const withReducer = compose(
  injectReducer({ key: 'AddressSearch', reducer: Reducer }),
  injectReducer({ key: 'cartReducer', reducer: cartReducer }),
  injectReducer({ key: 'cBandReducer', reducer: cBandReducer }),
);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
const withSaga = compose(
  injectSaga({ key: 'AddressSearch', saga }),
  injectSaga({ key: 'cartSaga', saga: cartSaga }),
  injectSaga({ key: 'cBandSaga', saga: cBandSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(
  compose(
    withReducer,
    withConnect,
    withSaga,
  )(AddressSearch),
);
